import * as types from '../constants/ActionTypes';
import { pageNames } from '../../../jsV2/common/constants';

const initialState = {
  isLoading: false,
  chatBotDisplay: false,
  chatBotTriggerMode: '',
  chatBotApplicationId: '',
  botType: '',
  error: false,
  chatBotAsync: false,
  mmtResponse: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_POST_CHATBOT_ELIGIBILITY:
      return {
        ...state,
        isLoading: true,
        chatBotDisplay: false,
        error: false,
      };
    case types.POST_CHATBOT_ELIGIBILITY_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        chatBotDisplay: action.payload.result === 'ELIGIBLE',
        chatBotTriggerMode: action.payload.trigger_mode,
        chatBotApplicationId: action.payload.bot_application_id,
        botType: action.payload.bot_type,
        chatBotAsync: action.payload.async,
        error: false,
      };
    }
    case types.POST_CHATBOT_ELIGIBILITY_ERROR:
      return {
        ...state,
        isLoading: false,
        error: true,
        chatBotDisplay: false,
      };
    case types.POST_CHATBOT_ELIGIBILITY_FALSE:
    case types.REQUEST_BY_EMAIL:
      return { ...state, chatBotDisplay: false };
    case types.MMT_CHECK_RESPONSE: {
      return {
        ...state,
        mmtResponse: action.payload,
      };
    }
    case types.CONTACT_LOCATION_CHANGE:
      // Making chatBot Eligibility False when user goes to call and email page
      if (action.payload.pageName === pageNames.CALL_US || action.payload.pageName === pageNames.EMAIL) {
        return { ...state, chatBotDisplay: false };
      }
      return state;
    default:
      return state;
  }
}
